'use client'

import { useTranslations } from 'next-intl'
import { useState } from 'react'

import { Button, Label, TextField } from '@/shared/ui'

import { useSendEmail } from '../../api/send-email'

type Props = {
  email: string
  isCodeSent: boolean
  onSendSuccess: (expiresIn: number) => void
}

export const EmailSendField = ({ isCodeSent, email, onSendSuccess }: Props) => {
  const t = useTranslations('email_verification')

  const [sentMessage, setSentMessage] = useState<string>()

  const { sendEmailAsync, isSending } = useSendEmail()

  const handleSendEmail = async () => {
    await sendEmailAsync(email, {
      onSuccess: ({ expiresIn }) => {
        setSentMessage(
          isCodeSent ? t('email.status_resent') : t('email.status_sent'),
        )
        onSendSuccess(expiresIn)
      },
      onError: errorMessage => {
        setSentMessage(errorMessage)
      },
    })
  }

  return (
    <div className="flex flex-col gap-2">
      <Label bold>{t('email.label')}</Label>
      <div className="flex gap-2">
        <TextField fullWidth value={email} readOnly tabIndex={-1} />
        <Button
          size="medium"
          variant="outline"
          onClick={handleSendEmail}
          disabled={isSending}
          className="w-[95px] shrink-0"
        >
          {isCodeSent ? t('button.resend_code') : t('button.send_code')}
        </Button>
      </div>
      {sentMessage && (
        <p className="typo-caption1 text-purple-500">{sentMessage}</p>
      )}
    </div>
  )
}
